/**
 * TRACK 3 — Resume card for the dashboard.
 *
 * Surfaces the operator's last sheet + project so opening ForgedOps drops
 * them right back where they were. Bluebeam-equivalent "last document"
 * muscle memory, plus we know the project context (Bluebeam doesn't).
 */
import { Link } from "react-router-dom";
import { ArrowRight, Clock } from "lucide-react";
import { workspace } from "@/lib/workspace";

function _ago(iso) {
  try {
    const dt = new Date(iso);
    const mins = Math.floor((Date.now() - dt.getTime()) / 60000);
    if (mins < 1) return "just now";
    if (mins < 60) return `${mins} min ago`;
    const hours = Math.floor(mins / 60);
    if (hours < 24) return `${hours} hour${hours === 1 ? "" : "s"} ago`;
    const days = Math.floor(hours / 24);
    return `${days} day${days === 1 ? "" : "s"} ago`;
  } catch {
    return "earlier";
  }
}

export function ResumeCard() {
  const last = workspace.getLastSheet();
  if (!last || !last.sheet_id) return null;

  return (
    <Link
      to={`/sheet/${last.sheet_id}`}
      className="block fop-surface-2 rounded-lg p-4 border border-[var(--fop-primary)]/40 hover:border-[var(--fop-primary)] transition-colors"
      data-testid="resume-card"
    >
      <div className="flex items-center gap-1 mb-2">
        <Clock size={11} className="text-[var(--fop-primary)]" />
        <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-[var(--fop-text-3)]">
          Resume last sheet
        </span>
      </div>
      <div className="text-sm font-semibold text-[var(--fop-text)] truncate" data-testid="resume-card-sheet-number">
        {last.sheet_number || "—"} · {last.sheet_title || "Untitled sheet"}
      </div>
      <div className="mt-1 flex items-center justify-between">
        <span className="text-[11px] text-[var(--fop-text-3)]">
          Opened {_ago(last.opened_at)}
        </span>
        <ArrowRight size={14} className="text-[var(--fop-primary)]" />
      </div>
    </Link>
  );
}

export default ResumeCard;
